<template>
  <v-app-bar color="primary" prominent>
    <v-app-bar-nav-icon
      variant="text"
      @click.stop="$emit('toggle-drawer')"
    ></v-app-bar-nav-icon>

    <v-toolbar-title>
      <v-row justify="left">
        <v-col cols="12" class="text-center" style="padding: 20px">
          <v-row justify="left">
            <v-img
              class="mt-1"
              src="/assets/hc-white.png"
              max-height="47"
              alt="Hotel Continental"
            ></v-img>
            <v-img
              :src="hotelLogo"
              class="logos-hotel mt-1"
              max-height="47"
              :alt="hotelName"
            ></v-img>
            <v-col cols="2" class="mt-2 text-center">
              Turno {{ cajaStore.lastCaja?.turno || '' }}
              <span>&nbsp;&nbsp;&nbsp;</span>
              {{ formatDate(cajaStore.lastCaja?.fecha) || '' }}
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <!-- User menu -->
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-card min-width="300">
        <v-card-text>
          <v-row>
            <v-col md="8">
              <strong>Usuario:</strong>
              {{ authStore.user?.usuario || 'N/A' }} ({{
                authStore.user?.iniciales || 'N/A'
              }})
            </v-col>
            <v-col md="4">
              <p>
                <strong>Turno:</strong> {{ authStore.user?.turno || 'N/A' }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-caption text-right"> v{{ version }} </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="logout">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { formatDate } from '@/utils/helpers'
import { useAuthStore } from '@/stores/authStore'
import { useCajaStore } from '@/stores/cajaStore'
import packageInfo from '../../package.json'

const authStore = useAuthStore()
const cajaStore = useCajaStore()
const router = useRouter()

const version = ref(packageInfo.version)

const hotelLogo = computed(() => {
  return authStore.user?.hotel === 'B'
    ? '/assets/barcelona.png'
    : '/assets/palacete.png'
})

const hotelName = computed(() => {
  switch (authStore.user?.hotel) {
    case 'B':
      return 'Barcelona'
    case 'P':
      return 'Palacete'
    default:
      return 'N/A'
  }
})

const logout = async () => {
  try {
    await authStore.logout()
    router.push('/login')
  } catch (error) {
    alert('Error cerrando la sesión')
  }
}

defineEmits(['toggle-drawer'])
</script>
